module.exports = __webpack_public_path__ + "img/reading.4079976c.svg";